import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <div>
      <section className="pt-16 md:pt-[130px] bg-[#331411]">
        <div className="theme-container w-full mx-auto">
          <div className="grid grid-cols-6 gap-5 md:grid-cols-10 bg-[#AF493E] rounded-xl py-10 md:py-[70px] px-5 md:px-[110px] relative">
            <div className="col-span-6 relative z-10">
              <div className="px-5 py-0.5 font-medium text-white rounded-[30px] border border-white/10 mb-5 w-fit bg-main-gray/5">
                <span>Let’s Talk Health!</span>
              </div>
              <div className="mb-6">
                <h2 className="text-white font-semibold text-24 sm:text-48 max-w-[449px]">
                  Have a question? Need help picking the right plan?
                </h2>
              </div>
              <p className="text-18 text-white mb-10">
                Our team is always here.
              </p>
              <Link to="tel:+91-9214562942">
                <div className="home-two-btn-bg py-4 group bg-[#d26154] border-[1px] border-[#AF493E]">
                  <span className="text-base text-white group-hover:text-[#AF493E] transition-all duration-300 font-semibold font-inter relative z-10">
                    Call Us
                  </span>
                  <svg
                    className="relative z-10"
                    width={7}
                    height={12}
                    viewBox="0 0 7 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      className="group-hover:stroke-[#AF493E] transition-all duration-300"
                      d="M1.10254 10.5L4.89543 6.70711C5.22877 6.37377 5.39543 6.20711 5.39543 6C5.39543 5.79289 5.22877 5.62623 4.89543 5.29289L1.10254 1.5"
                      stroke="white"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
              </Link>
            </div>
            <div
              id="home-four-cta-mouse-move"
              className="col-span-4 flex justify-center items-center relative"
              style={{
                transform: "translate3d(0px, 0px, 0px) rotate(0.0001deg)",
                transformStyle: "preserve-3d",
                backfaceVisibility: "hidden",
                pointerEvents: "none",
              }}
            >
              <div
                data-depth="0.80"
                className="layer relative z-10"
                style={{
                  transform: "translate3d(26.2px, -24.2px, 0px)",
                  transformStyle: "preserve-3d",
                  backfaceVisibility: "hidden",
                  position: "relative",
                  display: "block",
                  left: 0,
                  top: 0,
                }}
              >
                <img
                  data-aos="zoom-in"
                  data-aos-delay={100}
                  src="assets/images/cta-img.png"
                  alt=""
                  className="aos-init aos-animate"
                />
              </div>
              <div
                data-depth="0.20"
                className="layer absolute -right-10 z-0"
                style={{
                  transform: "translate3d(6.6px, -6.1px, 0px)",
                  transformStyle: "preserve-3d",
                  backfaceVisibility: "hidden",
                  position: "absolute",
                  display: "block",
                  left: 0,
                  top: 0,
                }}
              >
                <img src="assets/images/home-four/cta-box.svg" alt="" />
              </div>
            </div>
            <img
              src="assets/images/home-four/dot-img.webp"
              alt=""
              className="absolute bottom-0 left-0 z-0"
            />
          </div>
        </div>
      </section>

      <footer className="pt-10 md:pt-20 bg-[#331411]">
        <div className="theme-container mx-auto flex flex-wrap justify-between mb-16 gap-5">
          <div className="w-fit max-w-[280px]">
            <img src="assets/images/brand_logo.png" alt="logo" />
            <p className="max-w-[300px] text-white my-6 mt-[40px]">
              With a wide network of healthcare providers and a commitment to
              quality care, we stand by our promise: Care Nova, Always There.
            </p>
          </div>
          <div className="w-fit max-w-[300px]">
            <div className="max-w-[223px]">
              <h1 className="font-semibold text-18 text-white">Address</h1>
              <div className="flex gap-2 items-center relative group font-medium text-white hover:text-white transition-all duration-300 mt-3.5">
                <span className="transition-all duration-300">
                Kabir Nagar, Durgakund, Varanasi, Uttar Pradesh - 221005
                </span>
              </div>
              <h1 className="font-semibold text-18 text-white mt-6">Contact</h1>
              <div className="flex gap-2 items-center relative group font-medium text-white hover:text-white transition-all duration-300 mt-3.5">
                <span className="transition-all duration-300">
                  <a href="mailto:support@carenova.in">support@carenova.in</a>
                  <br />
                  <a href="tel:9214562942">+91 9214562942</a>
                </span>
              </div>
            </div>
          </div>
          <div className="w-fit max-w-[300px]">
            <div className="flex flex-col items-center">
              <div>
                <h1 className="font-semibold text-18 text-white">
                  Quick Links
                </h1>
                <ul className="mt-3.5">
                  <li className="mt-2">
                    <Link to="/">
                      <div className="flex gap-2 items-center relative group font-medium text-white hover:text-white transition-all duration-300 overflow-hidden">
                        <svg
                          className="absolute -left-2 transition-all duration-300 group-hover:left-0"
                          width="6"
                          height="12"
                          viewBox="0 0 6 12"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M1 1L5 6L1 11"
                            stroke="white"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        <span className="group-hover:translate-x-4 transition-all duration-300">
                          Home
                        </span>
                      </div>
                    </Link>
                  </li>
                  <li className="mt-2">
                    <Link to="/plans">
                      <div className="flex gap-2 items-center relative group font-medium text-white hover:text-white transition-all duration-300 overflow-hidden">
                        <svg
                          className="absolute -left-2 transition-all duration-300 group-hover:left-0"
                          width="6"
                          height="12"
                          viewBox="0 0 6 12"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M1 1L5 6L1 11"
                            stroke="white"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        <span className="group-hover:translate-x-4 transition-all duration-300">
                          Plans
                        </span>
                      </div>
                    </Link>
                  </li>
                  <li className="mt-2">
                    <Link to="/contact">
                      <div className="flex gap-2 items-center relative group font-medium text-white hover:text-white transition-all duration-300 overflow-hidden">
                        <svg
                          className="absolute -left-2 transition-all duration-300 group-hover:left-0"
                          width="6"
                          height="12"
                          viewBox="0 0 6 12"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M1 1L5 6L1 11"
                            stroke="white"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        <span className="group-hover:translate-x-4 transition-all duration-300">
                          Contact
                        </span>
                      </div>
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="w-fit max-w-[300px]">
            <div className="flex flex-col items-center">
              <div>
                <h1 className="font-semibold text-18 text-white">
                  Terms & Policies
                </h1>
                <ul className="mt-3.5">
                  <li className="mt-2">
                    <Link to="/term-of-use">
                      <div className="flex gap-2 items-center relative group font-medium text-white hover:text-white transition-all duration-300 overflow-hidden">
                        <svg
                          className="absolute -left-2 transition-all duration-300 group-hover:left-0"
                          width="6"
                          height="12"
                          viewBox="0 0 6 12"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M1 1L5 6L1 11"
                            stroke="white"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        <span className="group-hover:translate-x-4 transition-all duration-300">
                          Term of Use
                        </span>
                      </div>
                    </Link>
                  </li>
                  <li className="mt-2">
                    <Link to="/privacy-policy">
                      <div className="flex gap-2 items-center relative group font-medium text-white hover:text-white transition-all duration-300 overflow-hidden">
                        <svg
                          className="absolute -left-2 transition-all duration-300 group-hover:left-0"
                          width="6"
                          height="12"
                          viewBox="0 0 6 12"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M1 1L5 6L1 11"
                            stroke="white"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        <span className="group-hover:translate-x-4 transition-all duration-300">
                          Privacy Policy
                        </span>
                      </div>
                    </Link>
                  </li>
                  <li className="mt-2">
                    <Link to="/cancellation-policy">
                      <div className="flex gap-2 items-center relative group font-medium text-white hover:text-white transition-all duration-300 overflow-hidden">
                        <svg
                          className="absolute -left-2 transition-all duration-300 group-hover:left-0"
                          width="6"
                          height="12"
                          viewBox="0 0 6 12"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M1 1L5 6L1 11"
                            stroke="white"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        <span className="group-hover:translate-x-4 transition-all duration-300">
                          Cancellation Policy
                        </span>
                      </div>
                    </Link>
                  </li>
                  <li className="mt-2">
                    <Link to="/shipping-delivery-policy">
                      <div className="flex gap-2 items-center relative group font-medium text-white hover:text-white transition-all duration-300 overflow-hidden">
                        <svg
                          className="absolute -left-2 transition-all duration-300 group-hover:left-0"
                          width="6"
                          height="12"
                          viewBox="0 0 6 12"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M1 1L5 6L1 11"
                            stroke="white"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        <span className="group-hover:translate-x-4 transition-all duration-300">
                          Shipping And Delivery Policy
                        </span>
                      </div>
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="w-full md:h-[65px] py-4 bg-[#AF493E] relative z-10">
          <div className="theme-container mx-auto h-full">
            <div className="w-full h-full flex flex-col sm:flex-row justify-between items-center">
              <span className="text-white max-w-100">
                2025 © All rights reserved by
                <b className="text-white"> CareNova Health Service Pvt. Ltd.</b>
              </span>
              <div className="relative max-md:hidden">
                <Link
                  to=""
                  aria-label="go top"
                  className="w-[45px] h-[45px] rounded-full border-[3px] border-[#AF493E] flex justify-center items-center bg-[#F28775] absolute -top-[70px] md:-top-[55px]"
                >
                  <span>
                    <svg
                      width={45}
                      height={45}
                      viewBox="0 0 45 45"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle
                        cx="22.5"
                        cy="22.5"
                        r={21}
                        fill="#AF493E"
                        stroke="#AF493E"
                        strokeWidth={3}
                      />
                      <path
                        d="M19 21L23 17M23 17L27 21M23 17V29"
                        stroke="white"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
